// extracted by mini-css-extract-plugin
module.exports = {"assetActionIconButton":"styles_assetActionIconButton__F_fl_","sendButton":"styles_sendButton__6c2sX"};